import { MENU_ITEMS } from '@/constants';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const data = {
  states: [],
  menuItems: [
    {
      name: MENU_ITEMS.PERSONAL,
      title: 'Personal',
      icon: 'ic_menu_personal_active',
      link: 'personal',
      completed: false,
    },
    {
      name: MENU_ITEMS.ASSETS,
      title: 'Assets',
      icon: 'ic_menu_assets_active',
      link: 'assets',
      completed: false,
    },
    {
      name: MENU_ITEMS.BUSINESS,
      title: 'Business',
      icon: 'ic_menu_business_active',
      link: 'business',
      completed: false,
    },
    {
      name: MENU_ITEMS.EXPENSES,
      title: 'Expenses',
      icon: 'ic_menu_expenses_active',
      link: 'expenses',
      completed: false,
    },
    {
      name: MENU_ITEMS.QUALIFY,
      title: 'Qualify',
      icon: 'ic_menu_qualify_active',
      link: 'qualify',
      completed: false,
    },
    {
      name: MENU_ITEMS.FILE,
      title: 'File',
      icon: 'ic_menu_file_active',
      link: 'file',
      completed: false,
    },
  ],
  sections: [],
  sectionsLoadingStatus: '',
  formProgress: 0,
  zipCodeData: null,
  zipCodeLoading: false,
  isPersonalEditLimited: false,
  isAddressEditLimited: false,
  appProducts: [],
  isAppAccessPaid: false,
  appAccessType: 1,
  orders: [],
  isEasyFilingPaid: false,
  currentYearUserApplicationId: 0,
  currentApplicationData: null,
  applicationAccessStatus: '',
  isAppClosed: false,
};

export default {
  state: data,
  getters,
  mutations,
  actions,
};
